import { CircleSkeleton, Separator, Skeleton } from '@/_components';
import { CardContainer, ContainerLayout, SectionHeadingSkeleton } from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <CardContainer className="space-y-6" bodyClassName="3xl:px-6 px-4">
        <header className="mb-6 flex flex-row items-center justify-between gap-2 px-4">
          <div className="flex-1">
            <SectionHeadingSkeleton />
          </div>

          <div>
            <Skeleton className="h-8 w-40" />
          </div>
        </header>

        <main className="flex flex-col gap-6 md:flex-row">
          <article className="flex w-full flex-col gap-4">
            <section className="px-4">
              <header className="mb-6 flex items-center gap-3">
                <div>
                  <CircleSkeleton className="h-8 w-8" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-24" />
                </div>
              </header>

              <header className="mb-6 flex items-center gap-3">
                <div>
                  <CircleSkeleton className="h-6 w-6" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                </div>
              </header>

              <section className="flex w-full items-center gap-3">
                <div className="size-8" />
                <div className="text-accent __fresh-desk-body flex w-full flex-col gap-4 text-sm dark:text-white">
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-3/4" />
                </div>
              </section>
            </section>

            <Separator />

            <section className="mt-6 px-4">
              <header className="mb-6 flex items-center gap-3">
                <div>
                  <CircleSkeleton className="h-8 w-8" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-24" />
                </div>
              </header>

              <header className="mb-6 flex items-center gap-3">
                <div>
                  <CircleSkeleton className="h-6 w-6" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                </div>
              </header>

              <section className="flex w-full items-center gap-3">
                <div className="size-8" />
                <div className="text-accent __fresh-desk-body flex w-full flex-col gap-4 text-sm dark:text-white">
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-3/4" />
                </div>
              </section>
            </section>

            <section className="mt-6 px-4">
              <header className="mb-6 flex items-center gap-3">
                <div>
                  <CircleSkeleton className="h-8 w-8" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-24" />
                </div>
              </header>

              <header className="mb-6 flex items-center gap-3">
                <div>
                  <CircleSkeleton className="h-6 w-6" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                </div>
              </header>

              <section className="flex w-full items-center gap-3">
                <div className="size-8" />
                <div className="text-accent __fresh-desk-body flex w-full flex-col gap-4 text-sm dark:text-white">
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-6 w-3/4" />
                </div>
              </section>
            </section>
          </article>
        </main>
      </CardContainer>
    </ContainerLayout>
  );
}
